import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Articulo } from "@/shared/types/articulo";

export interface ArticuloEditCantidadRequest {
    cantidad: number
}

export async function editArticuloCantidad(id: string, request: ArticuloEditCantidadRequest): Promise<Articulo> {
    await sleep(1000);
    const response = await api.putForm("articulos/" + id + "/cantidad", request);
    return response.data;
}

export function useEditArticuloCantidadMutation(id: string, mutationConfig: MutationConfig<Articulo, ArticuloEditCantidadRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: ArticuloEditCantidadRequest) => await editArticuloCantidad(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["articulos"] });
        },
    })
}

export interface EditArticuloCantidadMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Articulo, ArticuloEditCantidadRequest>,
    children?: (mutationResult: MutationResult<Articulo, ArticuloEditCantidadRequest>) => ReactNode
}

export function EditArticuloCantidadMutation({
    id,
    children,
    mutationConfig
}: EditArticuloCantidadMutationProps) {
    const mutationResult = useEditArticuloCantidadMutation(id, mutationConfig);
    return children && children(mutationResult)
}